import React from 'react'

/** Shared class for text links on auth screens ("Sign up", "Change", "Forgot password?"). */
export const authLinkClass = 'font-medium text-primary transition-colors hover:text-primary/80'

/**
 * Auth card — NeatFit design system: r14, 1px border, p-8, no shadow.
 * The step count is stated in words ("STEP 1 OF 3") with a short segmented indicator,
 * followed by a 24 / 600 heading and a secondary line.
 */
export const AuthCard = ({ step, totalSteps, title, subtitle, children }) => (
  <div className="rounded-[14px] border border-slate-200 bg-white p-8">
    {step ? (
      <div className="mb-[22px] flex items-center justify-between">
        <span className="text-xs font-semibold uppercase tracking-[0.04em] text-slate-500">
          Step {step} of {totalSteps}
        </span>
        <div className="flex gap-1" aria-hidden="true">
          {Array.from({ length: totalSteps }, (_, i) => (
            <div
              key={i}
              className={`h-[3px] w-[18px] rounded-sm ${i < step ? 'bg-primary' : 'bg-slate-200'}`}
            />
          ))}
        </div>
      </div>
    ) : null}

    <h1 className="text-2xl font-semibold tracking-[-0.02em] text-slate-900">{title}</h1>
    {subtitle && <p className="mt-[7px] text-sm leading-normal text-slate-500">{subtitle}</p>}

    <div className="mt-[22px]">{children}</div>
  </div>
)

/** Secondary line that sits outside (below) the card. */
export const AuthAside = ({ children }) => (
  <p className="mt-5 text-center text-sm text-slate-500">{children}</p>
)

/** Field label (13 / 500). */
export const AuthLabel = ({ htmlFor, children }) => (
  <label htmlFor={htmlFor} className="mb-1.5 block text-[13px] font-medium text-slate-700">
    {children}
  </label>
)
